import { CLEAR_ALL } from "../actions_all";
import { getSessionLanguage } from "../../Commons/SessionLanguage";
import {
    i18nState, i18nActionTypes, SET_LOCALE, SET_CONTENT,
    DELETE_CONTENT, SET_LOCAL_CODE, CLEAR_I18N
} from "./types";

/*
Built on demand instead of being a constant, so the language the user selected
for the session is read back from localStorage every time the store is reset
(CLEAR_ALL is dispatched by SessionManager.login before authenticating).
*/
const getInitialState = (): i18nState => ({ localCode: getSessionLanguage() ?? 'ES' });

export function i18Reducer(state=getInitialState(), action: i18nActionTypes): i18nState {

    let newState = {...state};

    switch (action.type) {

        case SET_LOCALE:
            newState.locale = action.payload;
            break;

        case SET_CONTENT:
            newState.content = {...action.payload};
            break;

        case DELETE_CONTENT:
            newState.content = undefined;
            break;
        
        case SET_LOCAL_CODE:
            newState.localCode = action.payload;
            break;

        case CLEAR_ALL:
        case CLEAR_I18N:
            return getInitialState();

        default:
            break;
    }

    return newState;
}